<template>
  <div></div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
  mounted() {
    const token = this.$route.query.token;
    if (token) {
      this.$store.dispatch("setAuth", token).then(
        () => {
          /* success */
          window.close();
        },
        () => {
          /* failure */
          alert("noo");
        }
      );
    }
  }
};
</script>
